import { useIntl } from "react-intl";
import { Modal, Box, Button, Grid, FormLabel } from "@mui/material";
import { useEffect, useState } from "react";
import SaveIcon from "@mui/icons-material/Save";

const DownloadExcelModal = (props) => {
  const intl = useIntl();

  const modalStyle = {
    position: "relative",
    top: "40%",
    left: "45%",
    width: "20%",
    ml: "7%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    p: 4,
    borderRadius: 2,
  };

  const [openDownloadModal, setOpenDownloadModal] = useState(false);
  const handleCloseDownloadModal = () => setOpenDownloadModal(false);

  useEffect(() => {
    if (props.downloadLink.length > 0) {
      handleDownloadModal();
    }
  }, [props.downloadLink]);

  const handleDownloadModal = () => {
    setOpenDownloadModal(true);
  };

  const handleDownloadReport = () => {
    window.open(props.downloadLink, "_blank");
  };

  return (
    <Modal
      open={openDownloadModal}
      onClose={handleCloseDownloadModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      style={{ textAlign: "center" }}
    >
      <Box sx={modalStyle}>
        <Box>
          <Grid container>
            <Grid
              item
              sm={12}
              sx={{
                p: 1,
              }}
            >
              <FormLabel>
                {intl.formatMessage({ id: "ExcelReports.DownloadReport" })}
              </FormLabel>
            </Grid>
          </Grid>
        </Box>
        <Grid container>
          <Grid item sm={12}>
            <Button
              variant="contained"
              className="apeLigthBlueBackground"
              startIcon={<SaveIcon />}
              onClick={handleDownloadReport}
            >
              {intl.formatMessage({ id: "ExcelReports.Download" })}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default DownloadExcelModal;
